let domLoaded = false;
let igReady = false;
//test
function handleExperiments() {
  if (!domLoaded || !igReady) {
    return;
  }

  // Continue Shopping Link in Cart
  const continueShoppingTest = window.igData?.user.getTestGroup(
    "8184743b-caeb-457d-9592-f480f5fbb61e"
  );

  if (continueShoppingTest?.name === "Var A - link") {
    document.body.classList.add("c-continue-shopping-varA");
  } else if (continueShoppingTest?.name === "Var B - button") {
    document.body.classList.add("c-continue-shopping-varB");
  }

  // V_WM_COL_19 | Add Ratings on Collection Cards
  const looxReviewCardTest = window.igData?.user.getTestGroup(
    "98c1d7d4-ab01-44dc-8e17-1ebc15cbd5b4"
  );

  if (looxReviewCardTest?.name === "Var A") {
    document.body.classList.add("c-loox-review-card-varA");
  }

  // V_WM_PDP_38 | Shrink Size Selector & Prioritize “Upload Photo"
  const variantPickerTest = window.igData?.user.getTestGroup(
    "b8c97332-f84f-4556-a92e-cba688561de9"
  );

  if (variantPickerTest?.name === "Var A - ATF") {
    document.body.classList.add("c-variant-redesign-varB");
  } else if (variantPickerTest?.name === "Var B - Below ATC") {
    document.body.classList.add("c-variant-redesign-varA");
  } else {
    document.body.classList.add("c-variant-redesign-control");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});
window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});
